module.exports = __webpack_public_path__ + "media/components/src/assets/images/embellishments/points/point_02-1f0159e002277b320d0ea95de6caa9f8.svg";